import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";

import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import AboutPage from '../AboutPage/AboutPage';
import ServicePage from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import ProjectPage from '../ProjectPage/ProjectPage';
import ProjectSinglePage from '../ProjectSinglePage';
import BlogPage from '../BlogPage/BlogPage'
import BlogDetails from '../BlogDetails/BlogDetails'
import ContactPage from '../ContactPage/ContactPage';
import { LanguageContext } from '../../index';
const AllRoute = () => {

  const { language } = React.useContext(LanguageContext);

  // Define route prefixes for each language
  const langPrefix = language === 'pl' ? '/pl' : '/en';

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* English routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/home2" element={<HomePage2 />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/projects" element={<ProjectPage />} />
          <Route path="/project-single/:slug" element={<ProjectSinglePage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="/blog-en" element={<BlogPage />} />
          <Route path="/blog-single/:slug" element={<BlogDetails />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Polish routes */}
          <Route path="/strona-glowna" element={<Homepage />} />
          <Route path="/strona-glowna2" element={<HomePage2 />} />
          <Route path="/o-nas" element={<AboutPage />} />
          <Route path="/projekty" element={<ProjectPage />} />
          <Route path="/projekt/:slug" element={<ProjectSinglePage />} />
          <Route path="/uslugi" element={<ServicePage />} />
          <Route path="/usluga/:slug" element={<ServiceSinglePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetails />} />
          <Route path="/kontakt" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default AllRoute;
